@let view = presentation();
@if (view) {
  @switch (view.destination.kind) {
    @case ('internal') {
      <a
        class="evidence-citation"
        data-testid="report-evidence-link"
        [attr.data-citation-id]="citationId()"
        [attr.data-evidence-kind]="citationKind()"
        [class.evidence-citation--full]="display === 'full'"
        [class.evidence-citation--inline]="display === 'inline-text'"
        [class.evidence-citation--inferred]="isInferred()"
        [class.evidence-citation--cross-page]="view.crossPage"
        [routerLink]="view.destination.routerLink"
        [queryParams]="view.destination.queryParams"
        [attr.aria-label]="view.ariaLabel"
        [matTooltip]="view.tooltip"
        [matTooltipClass]="view.tooltipClass"
        matTooltipPosition="above"
      >
        @if (display !== 'inline-text') {
          <mat-icon class="evidence-citation__icon" aria-hidden="true">{{ iconName() }}</mat-icon>
        }
        <span class="evidence-citation__label">{{ display === 'marker' ? view.marker : view.visibleLabel }}</span>
        @if (display === 'full' && view.crossPage) {
          <mat-icon class="evidence-citation__badge" aria-hidden="true">open_in_new</mat-icon>
        }
      </a>
    }
    @case ('external') {
      <a
        class="evidence-citation evidence-citation--external"
        data-testid="report-evidence-link"
        [attr.data-citation-id]="citationId()"
        [attr.data-evidence-kind]="citationKind()"
        [class.evidence-citation--full]="display === 'full'"
        [class.evidence-citation--inline]="display === 'inline-text'"
        [class.evidence-citation--inferred]="isInferred()"
        [href]="view.destination.href"
        [target]="view.destination.target"
        [attr.rel]="view.destination.rel"
        [attr.aria-label]="view.ariaLabel"
        [matTooltip]="view.tooltip"
        [matTooltipClass]="view.tooltipClass"
        matTooltipPosition="above"
      >
        @if (display !== 'inline-text') {
          <mat-icon class="evidence-citation__icon" aria-hidden="true">{{ iconName() }}</mat-icon>
        }
        <span class="evidence-citation__label">{{ display === 'marker' ? view.marker : view.visibleLabel }}</span>
        @if (display === 'full') {
          <mat-icon class="evidence-citation__badge" aria-hidden="true">open_in_new</mat-icon>
        }
      </a>
    }
    @case ('none') {
      <!--
        A citation that cannot be linked is still shown. The reader is told the source exists and why
        it cannot be opened, rather than being left to assume the claim had no evidence behind it.
      -->
      <span
        class="evidence-citation evidence-citation--unlinkable"
        data-testid="report-evidence-unavailable"
        [attr.data-citation-id]="citationId()"
        [attr.data-evidence-kind]="citationKind()"
        [class.evidence-citation--full]="display === 'full'"
        [class.evidence-citation--inline]="display === 'inline-text'"
        [attr.aria-label]="view.visibleLabel + ', source unavailable. ' + view.destination.reason"
        [matTooltip]="view.destination.reason"
        matTooltipPosition="above"
      >
        <mat-icon class="evidence-citation__icon" aria-hidden="true">link_off</mat-icon>
        <span class="evidence-citation__label">{{ display === 'marker' ? view.marker : view.visibleLabel }}</span>
      </span>
    }
  }
}
